export default defineNuxtPlugin(() => {
  if (import.meta.client) {
    navigator.serviceWorker.getRegistrations().then(registrations => {
      if (registrations.length > 0) {
        const unregisterPromises = registrations.map(registration => registration.unregister())
        Promise.all(unregisterPromises).then(() => {
          console.log('Successfully unregistered service workers. Reloading...')
          window.location.reload()
        }).catch(error => {
          console.error('Error unregistering service workers:', error)
        });
      } else {
        console.log('No service workers to unregister.')
      }
    }).catch(error => {
      console.error('Error getting service worker registrations:', error)
    })
  }
})